import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useOpenItemViewer } from './useOpenItemViewer';

export const ItemViewerProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { isOpen, close: closeViewer } = useOpenItemViewer();
  const [closeHandler, setCloseHandler] = useState<() => void | undefined>();

  useEffect(() => {
    if (!isOpen) {
      setCloseHandler(undefined);
    }
  }, [isOpen]);

  return (
    <ItemViewerContext.Provider
      value={{
        closeViewer,
        closeHandler: closeHandler || closeViewer,
        setCloseHandler: (handler) => {
          setCloseHandler(() => handler);
        },
      }}
    >
      {children}
    </ItemViewerContext.Provider>
  );
};

export const useFolderItem = () => useContext(ItemViewerContext);

export type RenameHandler = (newName: string, onComplete: () => void) => void;

interface ItemViewerContextInterface {
  closeViewer(): void;

  closeHandler: () => void;
  setCloseHandler(handler?: () => void): void;
}

const initialContext: ItemViewerContextInterface = {
  closeViewer: () => {
    throw new Error('No FolderItemProvider found');
  },
  closeHandler: () => {
    throw new Error('No FolderItemProvider found');
  },
  setCloseHandler: () => {
    throw new Error('No FolderItemProvider found');
  },
};

export const ItemViewerContext =
  createContext<ItemViewerContextInterface>(initialContext);
